<template>
    <div class="crud-area">
        <div class="container-fluid">
            <div class="crud-header d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 class="crud-title">Categorias</h2>
                    <p class="crud-subtitle">Gerir as categorias dos projectos</p>
                </div>
                <button class="btn-primary-grad" @click="openCreate">
                    <i class="ri-add-line"></i> Nova Categoria
                </button>
            </div>

            <div v-if="loading" class="text-center py-5">
                <div class="spinner-border text-primary"></div>
            </div>
            <div v-if="error" class="alert-error mb-3"><i class="ri-error-warning-line"></i> {{ error }}</div>

            <div v-if="!loading" class="crud-card">
                <div class="table-responsive">
                    <table class="crud-table">
                        <thead>
                            <tr>
                                <th>Nome (PT)</th>
                                <th>Nome (EN)</th>
                                <th class="text-end">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="items.length === 0">
                                <td colspan="3" class="text-center text-muted py-4">Sem categorias registadas.</td>
                            </tr>
                            <tr v-for="item in items" :key="item.id">
                                <td>{{ item.name_pt }}</td>
                                <td>{{ item.name_en || '—' }}</td>
                                <td class="text-end">
                                    <button class="btn-icon edit" @click="openEdit(item)"><i class="ri-edit-line"></i></button>
                                    <button class="btn-icon delete" @click="confirmDelete(item)"><i class="ri-delete-bin-line"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- Modal Criar / Editar -->
        <div v-if="showModal" class="crud-modal-overlay" @click.self="closeModal">
            <div class="crud-modal crud-modal--sm">
                <div class="crud-modal-header">
                    <h3>{{ editing ? 'Editar Categoria' : 'Nova Categoria' }}</h3>
                    <button class="btn-close-modal" @click="closeModal"><i class="ri-close-line"></i></button>
                </div>
                <form @submit.prevent="save" class="crud-modal-body">
                    <div class="row g-3">
                        <div class="col-12">
                            <label>Nome (PT) *</label>
                            <input v-model="form.name_pt" class="form-input" required placeholder="Ex: Saúde" />
                        </div>
                        <div class="col-12">
                            <label>Nome (EN)</label>
                            <input v-model="form.name_en" class="form-input" placeholder="Ex: Health" />
                        </div>
                    </div>
                    <div class="crud-modal-footer mt-4">
                        <button type="button" class="btn-secondary" @click="closeModal">Cancelar</button>
                        <button type="submit" class="btn-primary-grad" :disabled="saving">
                            <span v-if="saving"><i class="ri-loader-4-line spin"></i> A guardar...</span>
                            <span v-else>{{ editing ? 'Guardar' : 'Criar' }}</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <!-- Confirmação de Eliminar -->
        <div v-if="showDelete" class="crud-modal-overlay" @click.self="showDelete = false">
            <div class="crud-modal crud-modal--sm">
                <div class="crud-modal-header">
                    <h3>Eliminar Categoria</h3>
                    <button class="btn-close-modal" @click="showDelete = false"><i class="ri-close-line"></i></button>
                </div>
                <div class="crud-modal-body">
                    <p>Tem a certeza que quer eliminar <strong>{{ selectedItem?.name_pt }}</strong>?</p>
                    <p class="text-muted small">Nota: não é possível eliminar categorias com projectos associados.</p>
                </div>
                <div class="crud-modal-footer">
                    <button class="btn-secondary" @click="showDelete = false">Cancelar</button>
                    <button class="btn-danger" @click="deleteItem" :disabled="saving">Eliminar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import categoriesService from '../../services/categoriesService';

export default {
    name: 'CategoriesContent',
    data() {
        return {
            items: [], loading: true, saving: false, error: '',
            showModal: false, showDelete: false,
            editing: false, selectedItem: null,
            form: { name_pt: '', name_en: '' },
        };
    },
    mounted() { this.load(); },
    methods: {
        async load() {
            this.loading = true; this.error = '';
            try {
                this.items = await categoriesService.getAll();
            } catch { this.error = 'Erro ao carregar categorias.'; }
            finally { this.loading = false; }
        },
        openCreate() {
            this.editing = false;
            this.form = { name_pt: '', name_en: '' };
            this.showModal = true;
        },
        openEdit(item) {
            this.editing = true; this.selectedItem = item;
            this.form = { name_pt: item.name_pt, name_en: item.name_en || '' };
            this.showModal = true;
        },
        closeModal() { this.showModal = false; },
        async save() {
            this.saving = true;
            try {
                if (this.editing) await categoriesService.update(this.selectedItem.id, this.form);
                else await categoriesService.create(this.form);
                this.closeModal(); this.load();
            } catch { this.error = 'Erro ao guardar categoria.'; }
            finally { this.saving = false; }
        },
        confirmDelete(item) { this.selectedItem = item; this.showDelete = true; },
        async deleteItem() {
            this.saving = true;
            try {
                await categoriesService.remove(this.selectedItem.id);
                this.showDelete = false; this.load();
            } catch { this.error = 'Erro ao eliminar categoria. Verifique se não tem projectos associados.'; }
            finally { this.saving = false; }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../Dashboards/GgmfDashboard/ggmf-card';
</style>
